import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { Link } from '@chakra-ui/react';

import * as Form from 'components/_core/form';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';

import { InvoicePresetsFormSchema } from '../../invoicePresetsForm.schema';
import locales from './locales';

const ARTICLE_LINK =
  'https://help.shine.fr/fr/articles/6715420-quelles-mentions-doivent-figurer-sur-mes-devis-factures';

interface LegalMentionsCardProps {
  control: Control<InvoicePresetsFormSchema>;
  isEnabled: boolean;
  onCheckChange: () => void;
}

const LegalMentionsCard: FC<LegalMentionsCardProps> = ({
  control,
  isEnabled,
  onCheckChange,
}) => (
  <SunshineCard.Group>
    <Controller
      control={control}
      name="legalMentionsEnabled"
      render={({ field }) => (
        <SunshineCard
          isChecked={field.value}
          onChange={(e) => {
            field.onChange(e.target.checked);
            onCheckChange();
          }}
          title={locales.label}
          variant="checkbox"
        />
      )}
    />

    {isEnabled ? (
      <SunshineCard>
        <Controller
          control={control}
          name="legalMentions"
          render={({ field, formState: { errors } }) => (
            <>
              <Form.Field error={errors.legalMentions?.message}>
                <Form.Textarea
                  onChange={(e) => field.onChange(e.target.value)}
                  value={field.value}
                />
              </Form.Field>
              <Text size="xs" variant="light">
                {locales.description.body}
                <Link
                  color="blue.600"
                  fontSize="font-13"
                  href={ARTICLE_LINK}
                  target="_blank"
                >
                  {locales.description.link}
                </Link>
                .
              </Text>
            </>
          )}
        ></Controller>
      </SunshineCard>
    ) : null}
  </SunshineCard.Group>
);

export default LegalMentionsCard;
